/** @jsxImportSource theme-ui */
import classNames from 'classnames';
import React, { useState } from 'react';
import { ThemeUIStyleObject } from 'theme-ui';

import { isKeyboardSelect } from 'utils/accessibilityHelpers';

import { BdIcon } from 'components/_common/BdIcon';
import { FlexGroup } from 'components/_common/FlexGroup';
import { Typography } from 'components/_common/Typography';

import { NavigationbarUrl } from '../Navigationbar';
import NavDrawerItem from './NavDrawerItem';

const Styles: ThemeUIStyleObject = {
  display: 'flex',
  flexDirection: 'column',
  borderBottom: '',
  '& .expand-header': { p: '32px 36px', cursor: 'pointer' },
  '& .submenu': {
    display: 'none',
    flexDirection: 'column',
    pb: '32px',
    '&.expanded': { display: 'flex', height: 'auto' },
  },
};

type NavDrawerExpandMenuProps = {
  navItem: NavigationbarUrl;
  onItemClick: (link: string) => void;
};

const NavDrawerExpandMenu: React.FC<NavDrawerExpandMenuProps> = ({ navItem, onItemClick }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  return (
    <div className="top-level-nav-item" sx={Styles}>
      <FlexGroup
        suffix={
          <BdIcon
            className="expand-icon"
            name={isExpanded ? 'icon-chevron-up' : 'icon-chevron-down'}
            color="white"
          />
        }
        className="drawer-item expand-header"
        role="button"
        tabIndex={0}
        onClick={() => setIsExpanded(!isExpanded)}
        onKeyDown={e => isKeyboardSelect(e) && setIsExpanded(!isExpanded)}
      >
        <Typography variant="body1" color="white" marginBottom="0" inline>
          {navItem.title}
        </Typography>
      </FlexGroup>
      <div className={classNames({ submenu: true, expanded: isExpanded })}>
        {navItem.children.map(childItem => (
          <NavDrawerItem
            key={`${navItem.title}-${childItem.title}`}
            subItem
            navItem={childItem}
            onClick={onItemClick}
          />
        ))}
      </div>
    </div>
  );
};

export default NavDrawerExpandMenu;
